import type { AttestationKind } from "@graftus/schema";

export { isTeamReady, TEAM_READINESS } from "@graftus/schema";

export interface CanSendInput {
  /** Which required kinds the manager has ticked. */
  attested: Partial<Record<AttestationKind, boolean>>;
  required: readonly AttestationKind[];
  when: "now" | "later";
  scheduledAt: string | null;
  recipientCount: number;
}

/** The send button is live only once every gate is passed; the reason it is not is returned. */
export function sendBlocker(
  input: CanSendInput,
): "noRecipients" | "attestation" | "noSlot" | null {
  if (input.recipientCount <= 0) return "noRecipients";
  if (input.required.some((kind) => !input.attested[kind])) return "attestation";
  if (input.when === "later" && !input.scheduledAt) return "noSlot";
  return null;
}

export function canSend(input: CanSendInput): boolean {
  return sendBlocker(input) === null;
}
